import React from "react";
import "./ProductListings.css";

import ProductShowcase from "../../components/ProductShowcase/ProductShowcase";
import NewArrival from "../../components/NewArrival/NewArrival";

const ProductListings = () => {
  return (
    <>
      <section className="product-listings">
        <div className="listings-container">
          <ProductShowcase />
        </div>

        {/* New Arrival Section */}
        <div className="listings-container">
          <NewArrival />
        </div>

        {/* Best Sellers Section
        <BestSellers /> */}

        {/* Newsletter Block */}
        <div className="block-newsletter">
          <ul className="messages newsletter-msg">
            <li
              className="success-msg"
              id="newsletter-msg"
              style={{ display: "none" }}
            >
              <ul>
                <li>
                  <span></span>
                </li>
              </ul>
            </li>
          </ul>
          <div className="block-newsletter-container">
            <svg
              width="170"
              height="160"
              viewBox="0 0 184 180"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_22_329)">
                <path
                  d="M64.791 174.143C100.303 159.229 135.814 144.314 171.326 129.4C171.261 128.848 171.794 128.809 172.06 128.592C178.162 123.556 179.924 116.206 176.787 108.737C171.536 96.2339 166.284 83.7284 161.033 71.2257C159.957 68.6642 157.99 67.8207 155.515 68.8601C149.594 71.3434 143.661 73.7891 137.773 76.3508C136.596 76.8615 136.257 76.5823 135.791 75.4642C127.225 54.9679 118.573 34.5044 110.064 13.984C109.041 11.5253 106.533 10.3196 103.951 11.4105C70.888 25.3916 37.7864 39.2804 4.6649 53.1216C2.61224 53.9804 1.29296 55.124 0.964083 57.3632C16.3275 93.9447 31.6898 130.523 47.0533 167.105C47.6594 167.14 47.7724 167.738 48.0552 168.09C51.7781 172.685 56.5464 174.704 62.2912 174.442C63.135 174.4 63.914 173.899 64.791 174.143ZM153.873 128.826C153.193 129.112 152.756 129.295 152.316 129.48C123.23 141.696 94.1401 153.913 65.0533 166.129C59.2403 168.57 54.537 166.56 52.0209 160.569C38.0318 127.261 24.0471 93.9466 10.0253 60.6515C9.50329 59.4085 9.62091 58.9541 10.8814 58.428C41.5811 45.5841 72.2592 32.6967 102.927 19.7773C104.121 19.2759 104.584 19.3613 105.134 20.6715C119.005 53.8128 132.948 86.9202 146.799 120.07C148.294 123.651 150.369 126.58 153.873 128.826ZM146.911 101.873C144.502 96.1368 142.111 90.3897 139.664 84.6695C139.304 83.8292 139.372 83.501 140.243 83.1485C145.04 81.1896 149.82 79.1791 154.58 77.1306C155.398 76.7769 155.715 76.8579 156.085 77.7465C160.832 89.1404 165.64 100.512 170.392 111.903C171.521 114.607 171.52 117.344 170.075 119.894C168.248 123.119 165.399 124.69 161.732 124.452C158.08 124.214 155.504 122.164 154.041 118.797C151.603 113.181 149.281 107.517 146.911 101.873Z"
                  fill="#687969"
                />
                <path
                  d="M91.9591 71.8371C97.2831 69.6012 102.612 67.3696 107.933 65.1253C110.204 64.168 110.968 62.2138 109.988 59.8722C106.82 52.314 103.646 44.7581 100.468 37.2044C99.469 34.8344 97.4387 33.9712 95.1414 34.9361C84.4894 39.4064 73.8414 43.8783 63.1918 48.3542C60.8863 49.3225 60.1028 51.2521 61.0771 53.5796C64.2622 61.1866 67.4583 68.789 70.6559 76.3874C71.6415 78.7267 73.5753 79.5513 75.8492 78.5996C81.2205 76.3537 86.5886 74.0926 91.9591 71.8371ZM89.2056 65.0896C85.1545 66.7909 81.0917 68.4643 77.0618 70.2161C76.1787 70.6001 75.8396 70.4659 75.4621 69.5442C73.471 64.6731 71.4334 59.8215 69.3494 54.9894C68.9579 54.0802 69.0913 53.7476 69.9858 53.3752C78.013 50.0467 86.0223 46.683 94.019 43.2818C94.9056 42.9061 95.2412 43.0319 95.6186 43.9536C97.6098 48.8247 99.6473 53.6763 101.731 58.5084C102.123 59.4176 101.993 59.7587 101.095 60.1226C97.1156 61.7346 93.1665 63.4261 89.2056 65.0896Z"
                  fill="#687969"
                />
                <path
                  d="M81.0583 96.175C92.4357 91.3967 103.814 86.6213 115.189 81.8374C116.929 81.1066 117.827 79.4716 117.475 77.7849C117.1 75.9962 115.642 74.8039 113.85 74.7625C113.328 74.7512 112.882 74.9056 112.429 75.0961C89.5374 84.71 66.6449 94.321 43.7559 103.941C41.7563 104.78 40.9795 106.78 41.8237 108.744C42.6584 110.685 44.6237 111.47 46.6506 110.619C58.1256 105.813 69.5908 100.991 81.0583 96.175Z"
                  fill="#687969"
                />
                <path
                  d="M88.7417 114.684C100.119 109.906 111.493 105.119 122.879 100.361C124.297 99.768 125.138 98.7696 125.262 97.2451C125.377 95.85 124.828 94.6809 123.647 93.8796C122.523 93.1166 121.364 93.0596 120.125 93.59C116.131 95.2971 112.119 96.9621 108.115 98.644C89.3646 106.519 70.6144 114.393 51.8643 122.268C49.7581 123.153 48.8212 124.847 49.3825 126.719C50.074 129.024 52.2006 130.024 54.4691 129.075C65.8991 124.284 77.3179 119.482 88.7417 114.684Z"
                  fill="#687969"
                />
                <path
                  d="M93.5624 126.492C82.1385 131.289 70.7163 136.083 59.2948 140.886C57.5711 141.61 56.692 143.274 57.0725 144.968C57.4743 146.759 58.9338 147.908 60.7379 147.934C61.3174 147.944 61.7974 147.733 62.2918 147.525C85.0478 137.971 107.803 128.415 130.556 118.856C132.711 117.95 133.562 116.052 132.741 114.042C131.888 111.957 129.932 111.217 127.695 112.157C116.316 116.932 104.94 121.713 93.5624 126.492Z"
                  fill="#687969"
                />
                <path
                  d="M42.445 68.92C46.1737 67.3541 49.9075 65.7925 53.6327 64.2181C55.7801 63.3097 56.6301 61.4082 55.807 59.4024C54.9521 57.3211 52.9986 56.5871 50.7602 57.5239C43.3441 60.6319 35.9303 63.7455 28.5162 66.8659C26.2735 67.8077 25.4205 69.7171 26.2991 71.7786C27.1707 73.8233 29.1242 74.5112 31.3926 73.5618C35.0761 72.0181 38.7599 70.4677 42.445 68.92Z"
                  fill="url(#paint0_linear_22_329)"
                />
                <path
                  d="M49.5841 85.6816C53.3128 84.1156 57.0478 82.5569 60.7718 80.9797C62.881 80.0873 63.6926 78.1327 62.8262 76.1156C61.9891 74.1684 60.0406 73.3928 58.0055 74.2475C50.4516 77.41 42.9001 80.5782 35.3545 83.7604C33.3315 84.6133 32.5227 86.5667 33.3351 88.5242C34.1484 90.4913 36.1205 91.3229 38.1236 90.4915C41.9468 88.9056 45.7625 87.2866 49.5841 85.6816Z"
                  fill="url(#paint1_linear_22_329)"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_22_329"
                  x1="39.6269"
                  y1="62.1947"
                  x2="42.4512"
                  y2="68.9196"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#C0DFC2" />
                  <stop offset="1" stop-color="#687969" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_22_329"
                  x1="46.6837"
                  y1="78.9936"
                  x2="49.5086"
                  y2="85.7198"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#C0DFC2" />
                  <stop offset="1" stop-color="#687969" />
                </linearGradient>
                <clipPath id="clip0_22_329">
                  <rect
                    width="142.214"
                    height="134.874"
                    fill="white"
                    transform="matrix(-0.921989 0.387216 0.387216 0.921989 131.12 0)"
                  />
                </clipPath>
              </defs>
            </svg>

            <h2 className="block-newsletter-title">
              Subscribe to Our <b>Newsletter</b>
            </h2>

            <div className="block-newsletter-email-signup">
              <form
                id="newsletter_form"
                className="newsletter_form"
                method="post"
                action=""
              >
                <input name="form_key" type="hidden" value="KSX5cMM7zlOKO8vd" />
                <input type="hidden" value="11" name="list" />
                <input
                  type="text"
                  className="txt required-entry validate-email newsletterEmail"
                  name="email"
                  id="email"
                  defaultValue="Enter E-mail Address"
                />
                <div id="g-recaptcha-element-newsLetter"></div>
                <input type="submit" className="cart-btn" value="SEND" />
              </form>
            </div>
          </div>
        </div>

        {/* Brand Features Component */}
        <div className="pl-infobar" aria-label="Store trust highlights">
          <div className="pl-infobar__item">
            <div className="pl-infobar__icon-wrap">
              <svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fill="white"
                  d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
                />
              </svg>
            </div>
            <div className="pl-infobar__text">
              <h4 className="pl-infobar__title">Trusted by 500+ Repair Shops</h4>
              <p className="pl-infobar__desc">Across the USA</p>
            </div>
          </div>

          <div className="pl-infobar__item">
            <div className="pl-infobar__icon-wrap">
              <svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fill="white"
                  d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
                />
              </svg>
            </div>
            <div className="pl-infobar__text">
              <h4 className="pl-infobar__title">Quality You Can Trust</h4>
              <p className="pl-infobar__desc">100% tested before shipping</p>
            </div>
          </div>

          <div className="pl-infobar__item">
            <div className="pl-infobar__icon-wrap pl-infobar__icon-wrap--return">
              <svg
                width="60"
                height="60"
                viewBox="0 0 60 60"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <circle cx="30" cy="30" r="30" fill="var(--pl-infobar-green)" />
                <path
                  d="M42 22 L42 32 Q42 38 36 38 L18 38"
                  fill="none"
                  stroke="white"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <polyline
                  points="23,33 18,38 23,43"
                  fill="none"
                  stroke="white"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="pl-infobar__text">
              <h4 className="pl-infobar__title">30 Days Return</h4>
              <p className="pl-infobar__desc">
                Hassle Free Returns on eligible items
              </p>
            </div>
          </div>

          <div className="pl-infobar__item">
            <div className="pl-infobar__icon-wrap">
              <svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fill="white"
                  d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
                />
              </svg>
            </div>
            <div className="pl-infobar__text">
              <h4 className="pl-infobar__title">Secure Payment</h4>
              <p className="pl-infobar__desc">Safe & Encrypted Transactions</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductListings;
